<template>
    <v-card>
        <v-toolbar class="darken-4" color="#003870" dark>
            <v-toolbar-title>
               {{$t('employee')}} {{$t('add')}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn @click="dialogueClose" dark text>
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
            <v-container>
                <form>
                    <v-card class="pa-4">
                        <div v-if="isSuperAdmin || isCompany">
                            <div class="employee-form-header">
                                <span>{{$t('company')}}</span>
                            </div>
                            <v-row>
                                <v-col cols="6" v-if="isSuperAdmin" >
                                    <v-autocomplete
                                            :items="listDDLData.companyList"
                                            @change="getDdlData(formData.companyID,'company')"
                                            item-text="value"
                                            item-value="id"
                                            :label="$t('company')"
                                            required dense outlined
                                            v-model="formData.companyID"
                                    >
                                    </v-autocomplete>
                                </v-col>

                                <v-col cols="6">
                                    <v-autocomplete
                                            :items="listDDLData.departmentCompanyList"
                                            @change="clearLowerData('company')"
                                            item-text="value"
                                            item-value="id" dense outlined
                                           :label="$t('department')"
                                            v-model="formData.departmentID"
                                    >
                                    </v-autocomplete>
                                </v-col>
                            </v-row>
                        </div>

                        <div  v-if="isSuperAdmin || isCompany || isBranch">
                            <div class="employee-form-header">
                                <span>{{$t('branch')}}</span>
                            </div>
                            <v-row>
                                <v-col cols="6" v-if="isSuperAdmin || isCompany">
                                    <v-autocomplete
                                            :items="listDDLData.branchList"
                                            @change="getDdlData(formData.companyID,'branch')"
                                            item-text="value"
                                            item-value="id" dense outlined
                                           :label="$t('branch')"
                                            v-model="formData.branchID"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="6">
                                    <v-autocomplete
                                            :items="listDDLData.departmentBranchList"
                                            @change="clearLowerData('branch')"
                                            item-text="value"
                                            item-value="id" dense outlined
                                            :label="$t('department')"
                                            v-model="formData.departmentID"
                                    >
                                    </v-autocomplete>
                                </v-col>
                            </v-row>
                        </div>

                        <div v-if="isSuperAdmin || isCompany || isBranch || isDepo">
                            <div class="employee-form-header">
                                <span>{{$t('depo')}}</span>
                            </div>
                            <v-row>
                                <v-col cols="6" v-if="isSuperAdmin || isCompany || isBranch">
                                    <v-autocomplete
                                            :items="listDDLData.depoList"
                                            @change="getDdlData(formData.companyID,'depo')"
                                            item-text="value"
                                            item-value="id"
                                             :label="$t('depo')" dense outlined
                                            v-model="formData.depoID">
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="6">
                                    <v-autocomplete
                                            :items="listDDLData.departmentDepoList"
                                            item-text="value"
                                            item-value="id" dense outlined
                                            :label="$t('department')"
                                            v-model="formData.departmentID"
                                    >
                                    </v-autocomplete>
                                </v-col>

                            </v-row>
                        </div>

                    </v-card>


                    <v-row>
                        <v-col cols="12"
                               md="4"
                               sm="6"
                        >
                            <v-text-field
                                    :error-messages="userFirstNameErrors"
                                    @blur="$v.formData.firstName.$touch()"
                                    @input="$v.formData.firstName.$touch()"
                                    :label="$t('first_name')"
                                    required dense outlined
                                    v-model="formData.firstName"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12"
                               md="4"
                               sm="6"
                        >
                            <v-text-field
                                    :error-messages="userLastNameErrors"
                                    @blur="$v.formData.lastName.$touch()"
                                    @input="$v.formData.lastName.$touch()"
                                     :label="$t('last_name')"
                                    required dense outlined
                                    v-model="formData.lastName"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12"
                               md="4"
                               sm="6"
                        >
                            <v-text-field
                                    :error-messages="userAddressErrors"
                                    @blur="$v.formData.address.$touch()"
                                    @input="$v.formData.address.$touch()"
                                     :label="$t('address')"
                                    required dense outlined
                                    v-model="formData.address"
                            ></v-text-field>
                        </v-col>
                        <!--                        <v-col cols="12"-->
                        <!--                               md="4"-->
                        <!--                               sm="6"-->
                        <!--                        >-->
                        <!--                            <v-text-field-->
                        <!--                                    :error-messages="userEmailErrors"-->
                        <!--                                    :label=" ' Email'"-->
                        <!--                                    @blur="$v.formData.email.$touch()"-->
                        <!--                                    @input="$v.formData.email.$touch()"-->
                        <!--                                    required-->
                        <!--                                    v-model="formData.email"-->
                        <!--                            ></v-text-field>-->
                        <!--                        </v-col>-->


                        <v-col cols="12"
                               md="4"
                               sm="6"
                        >
                            <v-text-field
                                    :error-messages="userPhoneErrors"
                                    @blur="$v.formData.phone.$touch()"
                                    @input="$v.formData.phone.$touch()"
                                    :label="$t('phone')"
                                    required dense outlined
                                    type="number"
                                    v-model="formData.phoneNumber"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12"
                               md="4"
                               sm="6"
                        >
                            <v-autocomplete
                                    :items="['Male','Female','Others']"
                                     :label="$t('gender')" dense outlined
                                    v-model="formData.gender"
                            >
                            </v-autocomplete>
                        </v-col>

                        <v-col cols="12"
                               md="4"
                               sm="6"
                        >
                            <v-autocomplete
                                    :items="listDDLData.designation"
                                    item-text="id" dense outlined
                                    item-value="value"
                                             :label="$t('designation')"
                                   
                                    v-model="formData.designation"
                            >
                            </v-autocomplete>
                        </v-col>

                    </v-row>
                    <v-row>
                        <v-col cols="12"
                               md="4"
                               sm="6">
                            <v-autocomplete :items="listDDLData.level"
                                            item-text="id" dense outlined
                                            item-value="value"
                                            :label="$t('level')"
                                            v-model="formData.level">
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12"
                               md="4"
                               sm="6">
                            <v-text-field :error-messages="userPISNumberErrors"
                                          @blur="$v.formData.pisNumber.$touch()"
                                          @input="$v.formData.pisNumber.$touch()"
                                          :label="$t('pis_number')"
                                          required dense outlined
                                          type="number"
                                          v-model="formData.pisNumber"></v-text-field>
                        </v-col>
                    </v-row>
                </form>

            </v-container>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="dialogueClose" color="red darken-1" dark>{{$t('cancel')}}</v-btn>
            <v-btn @click="checkPIS" class="custom-save-button" dark>{{$t('save')}}</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import {required} from "vuelidate/lib/validators";
    import axios from "axios";
    import {mapGetters} from "vuex";

    export default {
        name: "createEmployeeForm",
        props: ["success"],
        computed: {
            ...mapGetters({
                userRole: 'getUserRole',
                usersData: 'getUserData',
            }),
            isSuperAdmin() {
                return this.userRole === "SuperAdmin"
            },
            isCompany() {
                return this.userRole === "Company"
            },
            isDepartment() {
                return this.userRole === "Department"
            },
            isDepo() {
                return this.userRole === "Depo"
            },
            isBranch() {
                return this.userRole === "Branch"
            },
            userFirstNameErrors() {
                const errors = [];
                if (!this.$v.formData.firstName.$dirty) return errors;
                !this.$v.formData.firstName.required &&
                errors.push("First name is required.");
                return errors;
            },
            userLastNameErrors() {
                const errors = [];
                if (!this.$v.formData.lastName.$dirty) return errors;
                !this.$v.formData.lastName.required &&
                errors.push("Last name is required.");
                return errors;
            },
            userCompanyErrors() {
                const errors = [];
                if (!this.$v.formData.companyID.$dirty) return errors;
                !this.$v.formData.companyID.required &&
                errors.push("Company is required.");
                return errors;
            },
            userAddressErrors() {
                const errors = [];
                if (!this.$v.formData.address.$dirty) return errors;
                !this.$v.formData.address.required &&
                errors.push("User Address is required");
                return errors;
            },
            // userEmailErrors() {
            //     const errors = [];
            //     if (!this.$v.formData.email.$dirty) return errors;
            //     !this.$v.formData.email.required &&
            //     errors.push("User Email is required.");
            //     return errors;
            // },
            userPhoneErrors() {
                const errors = [];
                if (!this.$v.formData.phoneNumber.$dirty) return errors;
                !this.$v.formData.phoneNumber.required &&
                errors.push("Phone is required.");
                return errors;
            },
            userPISNumberErrors() {
                const errors = [];
                if (!this.$v.formData.pisNumber.$dirty) return errors;
                !this.$v.formData.pisNumber.required &&
                errors.push("PIS Number is required.");
                return errors;
            },
        },
        data() {
            return {
                userData: this.$store.getters.getUserData,
                role: this.$store.getters.getUserRole,
                listDDLData: {
                    companyList: [],
                    branchList: [],
                    depoList: [],
                    departmentCompanyList: [],
                    departmentBranchList: [],
                    departmentDepoList: [],
                    designation: [],
                    level: []
                },
                created: false,
                formData: {
                    companyID: null,
                    departmentID: null,
                    branchID: null,
                    depoID: null,
                    firstName: "",
                    lastName: "",
                    address: "",
                    phoneNumber: "",
                    gender: "",
                    designation: "",
                    level: "",
                    pisNumber:""
                },
                companyList: [],
                departmentList: [],
                branchList: [],
                designationList: [
                    {id: 1, value: 'Manager'},
                    {id: 2, value: 'Coordinator'}
                ],
                snackbar: {
                    dateMenu: false,
                    servicesData: {
                        data: {},
                        message: "",
                        color: ""
                    },
                }
            };
        },
        validations: {
            formData: {
                firstName: {required},
                lastName: {required},
                companyID: {required},
                // email: {required},
                address: {required},
                phoneNumber: {required},
                pisNumber: {required},
            },
        },
        mounted() {
            this.checkUserRole()
            this.getData()
        },
        methods: {
            checkUserRole() {
                if (this.role == "Company") {
                    this.formData.companyID = parseInt(this.userData.companyID)
                    this.getDdlData(this.formData.companyID, 'company')
                } else if (this.role == "Branch") {
                    this.formData.companyID = parseInt(this.userData.companyID)
                    this.getDdlData(this.formData.companyID, 'company')
                    this.formData.branchID = parseInt(this.userData.branchID)
                    this.getDdlData(this.formData.branchID, 'branch')
                } else if (this.role == "Depo") {
                    this.formData.companyID = parseInt(this.userData.companyID)
                    this.getDdlData(this.formData.companyID, 'company')
                    this.formData.branchID = parseInt(this.userData.branchID)
                    this.getDdlData(this.formData.branchID, 'branch')
                    this.formData.depoID = parseInt(this.userData.depoID)
                    this.getDdlData(this.formData.branchID, 'depo')
                }
            },
            dialogueClose() {
                this.formData = {};
                this.$emit("dialogueClose");
            },
            async getDepartmentList(index) {
                let departmentList = await axios.get("Department/DDLDepartmentList?CompanyID=" + index)
                this.departmentList = departmentList.data
                this.branchList = []
            },
            async getBranchList(index) {
                console.log(index)
                let branchList = await axios.get("Branch/DDLBranchList?DepartmentID=" + index)
                this.branchList = branchList.data
            },
            getDdlData(data, val) {
                let formVal = {}
                if (val == "company") {
                    this.listDDLData.branchList = []
                    this.listDDLData.depoList = []
                    this.listDDLData.departmentCompanyList = []
                    this.listDDLData.departmentBranchList = []
                    this.listDDLData.departmentDepoList = []
                    this.formData.branchID = ""
                    this.formData.depoID = ""
                    this.formData.departmentID = ""
                    formVal = {
                        companyID: this.formData.companyID
                    }
                    axios.get("Branch/DDLBranchList", {
                        params: formVal
                    }).then(response => {
                        this.listDDLData.branchList = response.data
                    })

                    axios.post('Department/DDLDepartmentList', formVal).then(response => {
                        this.listDDLData.departmentCompanyList = response.data
                    })

                } else if (val == "branch") {
                    this.listDDLData.depoList = []
                    this.listDDLData.departmentBranchList = []
                    this.listDDLData.departmentDepoList = []
                    this.formData.depoID = ""
                    this.formData.departmentID = ""

                    formVal = {
                        branchID: this.formData.branchID
                    }
                    axios.get("Depo/DDLDepoList", {
                        params: formVal
                    }).then(response => {
                        this.listDDLData.depoList = response.data
                    })

                    axios.post('Department/DDLDepartmentList', formVal).then(response => {
                        this.listDDLData.departmentBranchList = response.data
                    })


                } else if (val == "depo") {
                    this.listDDLData.departmentDepoList = []
                    this.formData.departmentID = ""

                    formVal = {
                        depoID: this.formData.depoID
                    }
                    axios.post('Department/DDLDepartmentList', formVal).then(response => {
                        this.listDDLData.departmentDepoList = response.data
                    })
                }

            },

            async getData() {

                console.log(parseInt(this.usersData.companyID))
                axios.get("Company/DDLCompanyList").then(response => {
                    this.listDDLData.companyList = response.data
                })

                axios.get("Employee/GetDesignationList").then(response => {
                    this.listDDLData.designation = response.data
                })
                axios.get("Employee/GetLevelList").then(response => {
                    this.listDDLData.level = response.data
                })


            },
            clearLowerData(val) {
                console.log(val)
                if (val == "company") {
                    this.listDDLData.depoList = []
                    this.listDDLData.departmentBranchList = []
                    this.listDDLData.departmentDepoList = []
                    this.formData.branchID = ""
                    this.formData.depoID = ""
                } else if (val == "branch") {
                    this.listDDLData.departmentDepoList = []
                    this.formData.depoID = ""
                }
            },

            formResponse() {
                this.$emit("formResponse", this.snackbar.servicesData);
                this.dialogueClose();
            },
            formResponseNotClose() {
                this.$emit("formResponse", this.snackbar.servicesData);
            },
            checkPIS() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.submitStatus = "ERROR";
                } else {
                    this.formData.pisNumber = parseInt(this.formData.pisNumber)
                    axios.post("Employee/CheckPIS", this.formData).then(response => {
                        if (response.data.existed) {
                            this.snackbar.servicesData.data = response.data
                            this.snackbar.servicesData.message = "PIS Number already exists"
                            this.snackbar.servicesData.color = "warning"
                            this.formResponseNotClose();
                        } else {
                            this.submit()
                        }
                    }).catch(response => {
                        this.snackbar.servicesData.data = response.data
                        this.snackbar.servicesData.message = "Error Updating User, Please Contact Admin"
                        this.snackbar.servicesData.color = "error"
                        this.formResponseNotClose();
                    });
                }
            },
            submit() {
                    this.formData.companyID = parseInt(this.formData.companyID)
                    this.formData.departmentID = parseInt(this.formData.departmentID)
                    this.formData.branchID = parseInt(this.formData.branchID)
                    this.formData.depoID = parseInt(this.formData.depoID)
                    this.formData.designation = parseInt(this.formData.designation)
                    this.formData.level = parseInt(this.formData.level)
                    this.formData.pisNumber = parseInt(this.formData.pisNumber)

                    axios.post("Employee/InsertAsync", this.formData).then(response => {
                        if (response.data.success) {
                            this.snackbar.servicesData.data = response.data
                            this.snackbar.servicesData.message = "User added Successfully"
                            this.snackbar.servicesData.color = "success"
                            this.formResponse()
                        }
                    }).catch(response => {
                        this.snackbar.servicesData.data = response.data
                        this.snackbar.servicesData.message = "Error Adding User, Please Contact Admin"
                        this.snackbar.servicesData.color = "error"
                    });
                
            },
            clear() {
                this.$v.$reset();
                this.formData = {};
            },
        }
    };
</script>

<style lang="scss" scoped>
    .employee-form-header {
        text-align: center;
        background-color: $main-color;
        height: 3em;
        padding: .6em;
        span {
            color: #ffffff;
            font-size: 1.4em;
        }
    }
</style>
